import React, { useContext } from 'react';
import styles from "../../../../styles/components/Modal/Employees/components/SideBar.module.css";
import { LangContext } from '../../../../context/LangContext';
import { ThemeContext } from '../../../../context/ThemeContext';

const translations = {
    ru: {
        personalData: "Персональные данные",
    },
    en: {
        personalData: "Personal Data",
    },
};

export const SideBar = ({ setActiveTab, activeTab, tabs, permissionGroupDisplayNames }) => {
    const { langSelected } = useContext(LangContext);
    const { theme } = useContext(ThemeContext);
    const t = translations[langSelected] || translations.ru;

    const sidebarClass = `${styles.sidebar} ${theme === 'dark' ? styles.darkSidebar : ''}`;

    return (
        <div className={sidebarClass}>
            <ul className={styles.tabList}>
                {tabs.map(tab => (
                    <li
                        key={tab}
                        className={`${styles.tabItem} ${activeTab === tab ? styles.activeTab : ''} ${theme === 'dark' ? styles.darkTabItem : ''}`}
                        onClick={() => setActiveTab(tab)}
                    >
                        {permissionGroupDisplayNames[tab] || (tab === 'personalData' ? t.personalData : tab)}
                    </li>
                ))}
            </ul>
        </div>
    );
};
